import { render } from "./TempBarComponent.vue?vue&type=template&id=7237b052"
import script from "./TempBarComponent.vue?vue&type=script&lang=js"
export * from "./TempBarComponent.vue?vue&type=script&lang=js"

import "./TempBarComponent.vue?vue&type=style&index=0&id=7237b052&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__